import { useEffect, useState } from "react";
import FilterDrawer from "components/drawers/host-side/FilterDrawer";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import { EventsFilterDTO } from "utils/helpers/models/host-dtos/events-filter.dto";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import useHost from "containers/host/useHooks";
import EventCard from "components/cards/event-card";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import noFoundGif from "assets/images/gifs/noFoundGif.gif";


const Experiences = () => {
  const { getQueryParams } = useUtils();
  const { id: hostId } = getQueryParams();
  const [filters, setFilters] = useState<Partial<EventsFilterDTO>>({
    page: 1,
    totalPages: 1,
    size: 12,
    hostId
  });
  const { getEvents } = useHost();
  const [data, setData] = useState<EventDTO[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const getAllEvents = (filters: Partial<EventsFilterDTO>) => {
    getEvents(setData, { ...filters, page: filters.page - 1 }, data, setFilters);
    setFilters({ ...filters });
    
    // Mark initial load as complete after first API call
    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  }

  useEffect(() => {
    getAllEvents(filters);
  }, []);

  return (
    <div className="container min-h-screen mb-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
        {data.map((event, index) => <EventCard event={event} key={index} />)}
      </div>
      {filters.totalPages > filters.page && (
        <div className="text-center mt-10">
          <button
            className="px-6 py-2 bg-fade text-primaryBlueText rounded-full"
            onClick={() =>
              getAllEvents({ ...filters, page: filters.page + 1 })
            }
          >
            See More
          </button>
        </div>
      )}

      <CustomMessageDisplay
        show={!isLoading && !data.length && !isInitialLoad}
        title="No Experiences Available"
        slogan="This host hasn't created any experiences yet. Check back later to see their upcoming events!"
        image={noFoundGif}
        imageAlt="No experiences found"
        className="py-12"
        imageClassName="w-24 h-24"
        titleClassName="text-2xl font-bold text-blackie"
        sloganClassName="text-gray-500 text-base"
      />
    </div>
  );
};

export default Experiences;
